const sliderInit = (n) => {
    document.querySelectorAll(".js-media-list") &&
        0 < 1 &&
        document.querySelectorAll(".js-media-list").forEach((t, i) => {
            let s;
            t.classList.contains("js-media-list-mobile")
                ? new ResizeObserver((e) => {
                      var [,] = e;
                      e.forEach((e) => {
                          575 < document.body.clientWidth
                              ? (s && s.destroy(), t.querySelector(".swiper-wrapper").removeAttribute("style"), t.classList.remove("swiper"))
                              : t.classList.contains("swiper-initialized") ||
                                (s = new Swiper(t, {
                                  slidesPerView: 1,
                                  slidesPerGroup: 1,
                                  navigation: { nextEl: ".product .product__slider-nav .swiper-button-next", prevEl: ".product .product__slider-nav .swiper-button-prev" },
                                  pagination: {
                                      el: ".product .product__pagination",
                                      type: "custom",
                                      renderCustom: function (e, t, i) {
                                          let s = "";
                                        const slides = document.querySelectorAll('.js-media-list-mobile .product__media-item');
                                        const visibleSlides = Array.from(slides).filter(slide => !slide.classList.contains('hidden'));

                                          for (let e = 1; e < visibleSlides.length + 1; e++)
                                              s =
                                                  e == t
                                                      ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                                      : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                                          return s;
                                      },
                                  },
                                  createElements: true,
                                  resizeObserver: true,
                                  zoom: true,
                                  keyboard: {
                                    enabled: true,
                                    onlyInViewport: true,
                                  },
                                  mousewheel: {
                                    forceToAxis: true,
                                  },
                                  a11y: { enabled: true },
                                  on: {
                                    slideChange: function () {
                                      window.pauseAllMedia(),
                                          (this.params.noSwiping = !1),
                                          document.querySelector(".js-popup-slider") && document.querySelector(".js-popup-slider").swiper && document.querySelector(".js-popup-slider").swiper.slideTo(this.activeIndex);
                                    },
                                    slideChangeTransitionEnd: function () {
                                      this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                                    },
                                    touchStart: function () {
                                        this.slides[this.activeIndex].querySelector("model-viewer") &&
                                            (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                                                ? (this.params.noSwiping = !1)
                                                : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                                    },
                                    zoomChange: function(swiper, scale) {
                                      if (scale > 1) {
                                        swiper.allowSlideNext = false
                                        swiper.allowSlidePrev = false
                                      } else {
                                        swiper.allowSlideNext = true
                                        swiper.allowSlidePrev = true
                                      }
                                    },
                                  }
                                }));
                                s && s.update();
                      });
                  }).observe(t.closest(".product__outer"))
                : t.classList.contains("stacked-media-list-mobile")
                ? new ResizeObserver((e) => {
                      var [,] = e;
                      e.forEach((e) => {
                          document.body.clientWidth <= 575
                              ? (s && s.destroy(), t.querySelector(".swiper-wrapper").removeAttribute("style"), t.classList.remove("swiper"))
                              : t.classList.contains("swiper-initialized") ||
                                ((s = new Swiper(t, {
                                    slidesPerView: 1,
                                    spaceBetween: 1,
                                    autoHeight: !1,
                                    speed: 500,
                                    navigation: { nextEl: ".product .product__slider-nav .swiper-button-next", prevEl: ".product .product__slider-nav .swiper-button-prev" },
                                    pagination: {
                                        el: ".product .product__pagination",
                                        type: "custom",
                                        renderCustom: function (e, t, i) {
                                            let s = "";
                                            for (let e = 1; e < i + 1; e++)
                                                s =
                                                    e == t
                                                        ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                                        : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                                            return s;
                                        },
                                    },
                                    thumbs: { swiper: 0 < document.querySelectorAll(".js-media-sublist").length ? document.querySelectorAll(".js-media-sublist")[i]?.swiper : "" },
                                    on: {
                                        afterInit: function (e) {},
                                        slideChangeTransitionStart: function () {
                                            document.querySelector(".js-media-sublist") && document.querySelector(".js-media-sublist").swiper.slideTo(document.querySelector(".js-media-list").swiper.activeIndex);
                                        },
                                        slideChange: function () {
                                            window.pauseAllMedia(),
                                                (this.params.noSwiping = !1),
                                                document.querySelector(".js-popup-slider") && document.querySelector(".js-popup-slider").swiper && document.querySelector(".js-popup-slider").swiper.slideTo(this.activeIndex);
                                        },
                                        slideChangeTransitionEnd: function () {
                                            this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                                        },
                                        touchStart: function () {
                                            this.slides[this.activeIndex].querySelector("model-viewer") &&
                                                (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                                                    ? (this.params.noSwiping = !1)
                                                    : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                                        },
                                    },
                                })),
                                n &&
                                    setTimeout(function () {
                                        s.update();
                                    }, 800));
                      });
                  }).observe(t.closest(".product__outer"))
                : t.classList.contains("swiper-initialized") ||
                  ((s = new Swiper(t, {
                      slidesPerView: 1,
                      spaceBetween: 1,
                      autoHeight: !1,
                      speed: 500,
                      navigation: { nextEl: ".product .product__slider-nav .swiper-button-next", prevEl: ".product .product__slider-nav .swiper-button-prev" },
                      pagination: {
                          el: ".product .product__pagination",
                          type: "custom",
                          renderCustom: function (e, t, i) {
                              let s = "";
                              for (let e = 1; e < i + 1; e++)
                                  s =
                                      e == t
                                          ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                          : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                              return s;
                          },
                      },
                      thumbs: { swiper: 0 < document.querySelectorAll(".js-media-sublist").length ? document.querySelectorAll(".js-media-sublist")[i]?.swiper : "" },
                      on: {
                          afterInit: function (e) {},
                          slideChangeTransitionStart: function () {
                            document.querySelector(".js-media-sublist") && document.querySelector(".js-media-sublist").swiper.slideTo(document.querySelector(".js-media-list").swiper.activeIndex);
                            // Pause the video in the previous active slide
                            const previousSlide = this.slides[this.previousIndex];
                            const previousVideo = previousSlide?.querySelector('video');
                            if (previousVideo) {
                                previousVideo.pause();
                            }
                          },
                          slideChange: function () {
                              window.pauseAllMedia(),
                                  (this.params.noSwiping = !1),
                                  document.querySelector(".js-popup-slider") && document.querySelector(".js-popup-slider").swiper && document.querySelector(".js-popup-slider").swiper.slideTo(this.activeIndex);
                          },
                          slideChangeTransitionEnd: function () {
                              this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                            // Play the video in the currently active slide
                            const activeSlide = this.slides[this.activeIndex];
                            const activeVideo = activeSlide?.querySelector('video');
                            if (activeVideo) {
                                activeVideo.play().catch((error) => console.error("Autoplay failed:21", error));
                            }
                          },
                          touchStart: function () {
                              this.slides[this.activeIndex].querySelector("model-viewer") &&
                                  (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                                      ? (this.params.noSwiping = !1)
                                      : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                          },
                      },
                  })),
                  n &&
                      setTimeout(function () {
                          s.update();
                      }, 800));
        });
},
subSliderInit = (s) => {
    document.querySelectorAll(".js-media-sublist") &&
        0 < document.querySelectorAll(".js-media-sublist").length &&
        document.querySelectorAll(".js-media-sublist").forEach((e, t) => {
            e.querySelectorAll(".product__media-subitem").length;
            let i = new Swiper(e, {
                slidesPerView: "auto",
                spaceBetween: 4,
                direction: "vertical",
                autoHeight: !0,
                freeMode: !1,
                watchSlidesProgress: !0,
                watchSlidesVisibility: !0,
                on: {
                    touchEnd: function (e, t) {
                        var i = (e.touches.diff = e.isHorizontal() ? e.touches.currentX - e.touches.startX : e.touches.currentY - e.touches.startY);
                        (i < 5 || -5 < i) && (e.allowClick = !0);
                    },
                },
            });
            s &&
                setTimeout(function () {
                    i.update();
                }, 800);
        });
},
popupSliderInit = (t) => {
    if (document.querySelector(".js-popup-slider")) {
        let e = new Swiper(document.querySelector(".js-popup-slider"), {
            zoom: true,
            slidesPerView: 1,
            navigation: { nextEl: ".product-media-modal .product__slider-nav .swiper-button-next", prevEl: ".product-media-modal .product__slider-nav .swiper-button-prev" },
            on: {
                afterInit: function () {
                    (document.querySelector(".product__outer--grid-gallery") || document.querySelector(".product__outer--stacked-gallery")) &&
                        document.querySelectorAll(".product__media-list .product__media-toggle").forEach((e, t) => {
                            e.addEventListener("click", (e) => {

                                // Checks if variant thumbnails enabled
                                if (document.querySelector('.product__info-container').getAttribute('data-product-variant-thumbnail')) {
                                    const clickedMediaId = e.target.dataset.mediaId;
                                    const popupSlider = document.querySelector(".js-popup-slider");
                            
                                    if (popupSlider && popupSlider.swiper && clickedMediaId) {
                                        const allSlides = popupSlider.querySelectorAll("[data-media-id]");
                                        const visibleSlides = Array.from(allSlides).filter(slide => 
                                            slide.closest('.swiper-slide').style.display !== "none"
                                        );
                            
                                        const targetIndex = visibleSlides.findIndex(slide => 
                                            slide.getAttribute("data-media-id") === clickedMediaId
                                        );
                            
                                        popupSlider.swiper.slideTo(targetIndex);
                                    }
                                } else {
                                    document.querySelector(".js-popup-slider") && document.querySelector(".js-popup-slider").swiper && document.querySelector(".js-popup-slider").swiper.slideTo(t);
                                }
                            });
                        });
                },
                slideChange: function () {
                    window.pauseAllMedia(), (this.params.noSwiping = !1), document.querySelector(".product-media-modal__content").classList.remove("zoom");
                },
                touchMove: function () {
                    document.querySelector(".product-media-modal__content").classList.remove("zoom");
                },
                slideChangeTransitionEnd: function () {
                    this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                },
                touchStart: function () {
                    this.slides[this.activeIndex].querySelector("model-viewer") &&
                        (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                            ? (this.params.noSwiping = !1)
                            : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                },
            },
        });
        t &&
            setTimeout(function () {
                e.update();
            }, 800);
    }
},
sliderQuickAddInit = (e) => {
    var t,
        i = e.querySelector(".product__media-list");
    if (i) {
        i.classList.contains("swiper") || (i.classList.add("swiper"), (t = i.innerHTML), (i.innerHTML = "<div class='swiper-wrapper'>" + t + "</div>"));
        const s = new Swiper(e.querySelector(".product__media-list"), {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 8,
            speed: 500,
            navigation: { nextEl: e.querySelector(".product__slider-nav .swiper-button-next"), prevEl: e.querySelector(".product__slider-nav .swiper-button-prev") },
            pagination: {
                el: e.querySelector(".product__pagination"),
                type: "custom",
                renderCustom: function (e, t, i) {
                    let s = "";
                    for (let e = 1; e < i + 1; e++)
                        s =
                            e == t
                                ? `${s}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                                : `${s}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                    return s;
                },
            },
            breakpoints: { 750: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 } },
            on: {
                slideChangeTransitionStart: function () {
                    document.querySelector(".product__media-list") && document.querySelector(".product__media-list").swiper.slideTo(document.querySelector(".product__media-list").swiper.activeIndex);
                },
                slideChange: function () {
                    window.pauseAllMedia(), (this.params.noSwiping = !1);
                },
                slideChangeTransitionEnd: function () {
                    this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                },
                touchStart: function () {
                    this.slides[this.activeIndex].querySelector("model-viewer") &&
                        (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                            ? (this.params.noSwiping = !1)
                            : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                },
            },
        });
        setTimeout(function () {
            s.update();
        }, 800);
    }
};
function getFocusableElements(e) {
return Array.from(e?.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
function onKeyUpEscape(e) {
var t;
"ESCAPE" === e.code.toUpperCase() && (e = e.target.closest("details[open]")) && ((t = e.querySelector("summary")), e.removeAttribute("open"), t.setAttribute("aria-expanded", !1), t.focus());
}
-1 < navigator.userAgent.indexOf("iPhone") && document.querySelector("[name=viewport]").setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1"),
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
        e.setAttribute("aria-expanded", "false"),
        e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
        e.addEventListener("click", (e) => {
            e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
        }),
        e.closest("header-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(t, e = t) {
var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
        (e.target !== t && e.target !== n && e.target !== s) || document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
        "TAB" === e.code.toUpperCase() && (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()), e.target === t || e.target === s) && e.shiftKey && (e.preventDefault(), n.focus());
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e?.focus();
}
function removeTrapFocus(e = null) {
document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && !e.classList.contains("card-focused") && e.focus();
}
window.pauseAllMedia = async function (i) {
var e = document.querySelectorAll("deferred-media video"),
    t = document.querySelectorAll("deferred-media iframe"),
    s = document.querySelectorAll("deferred-media model-viewer");
const n = [];
return (
    e.forEach((e) => {
        e !== i && void 0 !== (e = e.pause()) && n.push(e);
    }),
    t.forEach((e) => {
        var t = e.src;
        e !== i && (t && t.includes("youtube.com") ? e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*") : t && t.includes("vimeo.com") && void 0 !== (t = new Vimeo.Player(e).pause()) && n.push(t));
    }),
    s.forEach((e) => {
        e !== i && ((e = e.modelViewerUI) && "function" == typeof e.pause ? void 0 !== (e = e.pause()) && n.push(e) : console.error("modelViewerUI or its pause function is not available."));
    }),
    Promise.all(n)
);
};
class QuantityInput extends HTMLElement {
constructor() {
    super(),
        (this.input = this.querySelector("input")),
        (this.changeEvent = new Event("change", { bubbles: !0 })),
        this.querySelectorAll("button").forEach((e) => {
            this.setMinimumDisable(), e.addEventListener("click", this.onButtonClick.bind(this));
        });
    const quantityInput = this
    for (event of ["paste", "input"])
        this.input.addEventListener(event, function (e) {
            /^0*?[1-9]\d*$/.test(e.currentTarget.value) || "" === e.currentTarget.value ? e.currentTarget.value : (e.currentTarget.value = 1),
                1 === e.currentTarget.value || "" === e.currentTarget.value ? this.previousElementSibling.classList.add("disabled") : this.previousElementSibling.classList.remove("disabled");
        });
    this.input.addEventListener("focusout", function (e) {
        "" === e.currentTarget.value && (e.currentTarget.value = 1);
    });
    this.input.addEventListener("change", function (e) {
      quantityInput.checkPurchaseLimit()
    });
    quantityInput.checkPurchaseLimit()
}
checkPurchaseLimit(reset = false) {
    const qtyInput = this.querySelector('.quantity__input')
    const qtyInputValue = parseInt(qtyInput.value, 10)
    const plusBtn = this.querySelector('.quantity__button-plus')
    const minusBtn = this.querySelector('.quantity__button-minus')
    let totalProductQuantity = parseInt(this.input.dataset.totalQuantity, 10)
    const purchaseLimit = parseInt(this.input.dataset.purchaseLimit, 10)
    const productType = this.input.dataset.productType
    const inventory = parseInt(this.input.dataset.inventory, 10)
    const continueSelling = this.input.dataset.continueSelling
    const templateType = this.input.dataset.templateType
    let pdpQtySelectorVal = ''

    if (templateType == 'product') {
      const productForm = this.closest('.product-form')
      pdpQtySelectorVal = productForm.querySelector('.quantity__input').value
      pdpQtySelectorVal = parseInt(pdpQtySelectorVal, 10)
    }

    if (qtyInputValue > 1) {
      minusBtn.removeAttribute('disabled')
      minusBtn.classList.remove('disabled')
    }

    if (reset) {
        if (purchaseLimit && purchaseLimit <= totalProductQuantity) {
            if (qtyInputValue > purchaseLimit) {
                qtyInput.value = purchaseLimit
            }
        } else {
            qtyInput.value = 1
        }
    }
    if (productType == "Bundle") {
      if (templateType == 'product') {
        if (continueSelling == 'continue') {
          if (purchaseLimit && purchaseLimit <= pdpQtySelectorVal) {
            plusBtn.setAttribute('disabled', '')
            plusBtn.classList.add('disabled')
          } else {
            plusBtn.removeAttribute('disabled')
            plusBtn.classList.remove('disabled')
          }
        } else {
          if ((purchaseLimit && purchaseLimit <= totalProductQuantity) || (purchaseLimit && purchaseLimit <= pdpQtySelectorVal)) {
            plusBtn.setAttribute('disabled', '')
            plusBtn.classList.add('disabled')
          } else {
            plusBtn.removeAttribute('disabled')
            plusBtn.classList.remove('disabled')
          }
        }
      } else {
        if (inventory && totalProductQuantity >= inventory) {
          plusBtn.setAttribute('disabled', '')
          plusBtn.classList.add('disabled')
        } else {
          if (purchaseLimit && purchaseLimit <= totalProductQuantity) {
            plusBtn.setAttribute('disabled', '')
            plusBtn.classList.add('disabled')
          } else {
            plusBtn.removeAttribute('disabled')
            plusBtn.classList.remove('disabled')
          }
        }
      }
    } else {
        if (templateType == 'product') {
            totalProductQuantity = qtyInputValue
        }
        if (continueSelling == 'continue') {
            if (purchaseLimit && purchaseLimit <= totalProductQuantity) {
                plusBtn.setAttribute('disabled', '')
                plusBtn.classList.add('disabled')
            } else {
                plusBtn.removeAttribute('disabled')
                plusBtn.classList.remove('disabled')
            }
        } else {
            if (inventory > 0) {
              if (qtyInputValue >= inventory) {
                plusBtn.setAttribute('disabled', '')
                plusBtn.classList.add('disabled')
              } else {
                if (purchaseLimit && purchaseLimit <= totalProductQuantity) {
                  plusBtn.setAttribute('disabled', '')
                  plusBtn.classList.add('disabled')
                } else {
                  plusBtn.removeAttribute('disabled')
                  plusBtn.classList.remove('disabled')
                }
              }
            } else {
                plusBtn.setAttribute('disabled', '')
                plusBtn.classList.add('disabled')
            }
        }
    }
    this.setMinimumDisable()
    this.setButtonState()
}
setMinimumDisable() {
    const minusButton = this.querySelector('button[name="minus"]');
    if (!minusButton) return; // Exit if button not found
    
    if (this.input.value < 2) {
        minusButton.classList.add("disabled");
    } else {
        minusButton.classList.remove("disabled");
    }
}
  onButtonClick(e) {
    e.preventDefault();
    e.target.disabled = true;
    e.target.classList.add('disabled');
    // Prevent rapid quantity increment clicks
    debounce(this.debouncedButtonClick(e),500)
  }
  debouncedButtonClick(e) {
    setTimeout(() => {
      e.target.disabled = false;
      e.target.classList.remove('disabled');
      var t = this.input.value;
      "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }, 1000);
  }
  async setButtonState() {
    const productForm = this.closest("product-form") || '';
    if (productForm != '') {
      const plusBtn = productForm.querySelector('[name="plus"]');
      const infoWrapper = productForm.closest('.product__info-container');
      const variantSelects = infoWrapper.querySelector('variant-selects');
      const variantDropdowns = variantSelects.querySelectorAll('select');
      let isUnavailable = this.selectValues(variantDropdowns);
      const qtyInput = this.querySelector('[name="quantity"]');
      const atcButton = productForm.querySelector('[name="add"]');
      const atcButtonText = atcButton.querySelector('span');
      const productId = parseInt(qtyInput.dataset.productId);
      const cartProductQtys = await getCartProductQuantities();
      const currentVariant = infoWrapper.querySelector('variant-selects').currentVariant;
      const continueSelling = qtyInput.dataset.continueSelling;
      const inventory = parseInt(qtyInput.dataset.inventory, 10);
      
      if (currentVariant) {
        let purchaseLimit = qtyInput.dataset.purchaseLimit;
        if (continueSelling == 'continue') {
          if (purchaseLimit == '' || purchaseLimit == 0 || purchaseLimit == 'null') {
            return;
          }
        } else {
          if (purchaseLimit > inventory) {
            purchaseLimit = inventory;
          }
        }
        
        const productInCart = cartProductQtys[productId];
        let qtyInCart = 0;
        let remainder = 0;
        let productPurchaseLimit = 0;

        if (productInCart > 0) {
          qtyInCart = productInCart;
          productPurchaseLimit = purchaseLimit - qtyInCart;
          remainder = productPurchaseLimit - qtyInput.value;

          if (productPurchaseLimit < 0) {
            productPurchaseLimit = 0;
          }
          if (productPurchaseLimit <= 1 || remainder < 1) {
            plusBtn.classList.add('disabled');
            plusBtn.setAttribute('disabled', true);
            
            if (productPurchaseLimit < 1 ) {
              variantSelects.toggleAddButton(true, window.variantStrings.unavailable);
            } else {
              variantSelects.toggleAddButton(false, window.variantStrings.addToCart);
            }
          } else {
            variantSelects.toggleAddButton(false, window.variantStrings.addToCart);
          }
        } else {
          if (isUnavailable == true) {
            plusBtn.classList.add('disabled');
            plusBtn.setAttribute('disabled', true);
            variantSelects.toggleAddButton(true, window.variantStrings.unavailable);
          } else {
            if (qtyInput.value >= purchaseLimit) {
              plusBtn.classList.add('disabled');
              plusBtn.setAttribute('disabled', true);
            } else {
              atcButton.disabled = false;
              atcButtonText.textContent = window.variantStrings.addToCart;
            }
          }
        }
      }
    }
  }
  selectValues(selectors) {
    const allDropdownValues = Array.from(selectors).map(dropdown => dropdown.value);
    return allDropdownValues.some(item =>
      item.toLowerCase().includes("unavailable")
    );
  }
}
function debounce(t, i) {
let s;
return (...e) => {
    clearTimeout(s), (s = setTimeout(() => t.apply(this, e), i));
};
}
customElements.define("quantity-input", QuantityInput);
const serializeForm = (e) => {
var t = {},
    i = new FormData(e);
for (const s of i.keys()) t[s] = i.get(s);
return JSON.stringify(t);
};
function fetchConfig(e = "json") {
return { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/" + e } };
}
void 0 === window.Shopify && (window.Shopify = {}),
(Shopify.bind = function (e, t) {
    return function () {
        return e.apply(t, arguments);
    };
}),
(Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
        var n = e.options[i];
        if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i);
    }
}),
(Shopify.addListener = function (e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
}),
(Shopify.postLink = function (e, t) {
    var i,
        s = (t = t || {}).method || "post",
        n = t.parameters || {},
        o = document.createElement("form");
    for (i in (o.setAttribute("method", s), o.setAttribute("action", e), n)) {
        var a = document.createElement("input");
        a.setAttribute("type", "hidden"), a.setAttribute("name", i), a.setAttribute("value", n[i]), o.appendChild(a);
    }
    document.body.appendChild(o), o.submit(), document.body.removeChild(o);
}),
(Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
        (this.provinceEl = document.getElementById(t)),
        (this.provinceContainer = document.getElementById(i.hideElement || t)),
        Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
        this.initCountry(),
        this.initProvince();
}),
(Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var e = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
        var e = this.provinceEl.getAttribute("data-default");
        e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
        var t = (s = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
            i = JSON.parse(t);
        if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
        else {
            for (var s, n = 0; n < i.length; n++) ((s = document.createElement("option")).value = i[n][0]), (s.innerHTML = i[n][1]), this.provinceEl.appendChild(s);
            this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function (e) {
        for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
        var i = 0;
        for (t.length; i < t.length; i++) {
            var s = document.createElement("option");
            (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
        }
    },
});
class MenuDrawer extends HTMLElement {
constructor() {
    super(), (this.mainDetailsToggle = this.querySelector("details"));
    var e = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(e),
        "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", window.innerHeight + "px"),
        this.addEventListener("keyup", this.onKeyUp.bind(this)),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.bindEvents();
}
bindEvents() {
    this.querySelectorAll("summary").forEach((e) => {
        e.addEventListener("click", this.onSummaryClick.bind(this));
    }),
        this.querySelectorAll("button").forEach((t) => {
            [".toggle-scheme-button", ".header__localization-button", ".header__localization-lang-button", ".mobile-localization-form__back--reg", ".mobile-localization-form__back--lang"].some((e) => t.matches(e)) ||
                t.addEventListener("click", this.onCloseButtonClick.bind(this));
        });
}
addAccessibilityAttributes(e) {
    e.forEach((e) => {
        e.setAttribute("role", "button"), e.setAttribute("aria-expanded", !1), e.setAttribute("aria-controls", e.nextElementSibling.id);
    });
}
onKeyUp(e) {
    "ESCAPE" === e.code.toUpperCase() && (e = e.target.closest("details[open]")) && (e === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e));
}
onSummaryClick(e) {
    var t = e.currentTarget;
    const i = t.parentNode;
    var s = i.hasAttribute("open");
    i === this.mainDetailsToggle
        ? (s && e.preventDefault(), s ? this.closeMenuDrawer(t) : this.openMenuDrawer(t))
        : (trapFocus(t.nextElementSibling, i.querySelector("button")),
          setTimeout(() => {
              i.classList.add("menu-opening");
          }));
}
openMenuDrawer(e) {
    setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
    }),
        e.setAttribute("aria-expanded", !0),
        trapFocus(this.mainDetailsToggle, e),
        document.querySelector('#MainContent').classList.add("overflow-hidden-drawer"),
        document.querySelector('.shopify-section-group-footer-group').classList.add("overflow-hidden-drawer");
}
closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
        (this.mainDetailsToggle.classList.remove("menu-opening"),
        this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
            e.removeAttribute("open"), e.classList.remove("menu-opening");
        }),
        this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1),
        document.querySelector('#MainContent').classList.remove("overflow-hidden-drawer"),
        document.querySelector('.shopify-section-group-footer-group').classList.remove("overflow-hidden-drawer"),
        removeTrapFocus(t),
        this.closeAnimation(this.mainDetailsToggle));
}
onFocusOut(e) {
    (e.relatedTarget && e.relatedTarget.classList.contains("mobile-localization-form__back")) ||
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
}
onCloseButtonClick(e) {
    e = e.currentTarget.closest("details");
    this.closeSubmenu(e);
}
closeSubmenu(e) {
    e.classList.remove("menu-opening"), removeTrapFocus(), this.closeAnimation(e);
}
closeAnimation(t) {
    let i;
    const s = (e) => {
        e - (i = void 0 === i ? e : i) < 400 ? window.requestAnimationFrame(s) : (t.removeAttribute("open"), t.closest("details[open]") && trapFocus(t.closest("details[open]"), t.querySelector("summary")));
    };
    window.requestAnimationFrame(s);
}
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
constructor() {
    super();
}
openMenuDrawer(e) {
    (this.headerWrapper = document.querySelector(".header-wrapper")),
        document.documentElement.style.setProperty("--header-bottom-position", parseInt(this.headerWrapper.getBoundingClientRect().top) + "px"),
        document.querySelector("main").querySelectorAll(".shopify-section")[0].classList.contains("section--has-overlay"),
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
        e.setAttribute("aria-expanded", !0),
        trapFocus(this.mainDetailsToggle, e),
        document.querySelector('#MainContent').classList.add("overflow-hidden-drawer"),
        document.querySelector('.shopify-section-group-footer-group').classList.add("overflow-hidden-drawer");
}
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
constructor() {
    super();
    var e = this.querySelector('[id^="ModalClose-"]');
    e && e.addEventListener("click", () => this.hide(!1)),
        this.addEventListener("keyup", ({ code: e }) => {
            "ESCAPE" === e?.toUpperCase() && this.hide();
        }),
        this.classList.contains("media-modal")
            ? this.addEventListener("pointerup", ({ pointerType: e, target: t }) => {
                  "mouse" !== e || t.closest("deferred-media, product-model") || this.hide();
              })
            : this.addEventListener("click", ({ target: e }) => {
                  e === this && this.hide();
              });
}
connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
}
show(e) {
    // Adds max z-index class to global video toggle to ensure it sits above quickview (when open)
    if (document.querySelector('.global-video-control')) {
        document.querySelector('.global-video-control').classList.add('global-video-control-max-z-index');
    }
    this.openedBy = e;
    e = this.querySelector(".template-popup");
    // extra back-in-stock styles
    var backInStock = this.querySelector('back-in-stock-form')
    if (backInStock) {
        backInStock.showForm()
    }
    document.documentElement.classList.add("no-scroll"), this.setAttribute("open", ""), e && e.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
}
hide(e = !0) {
  // Removes max z-index class on global video toggle when closed
  if (document.querySelector('.global-video-control')) {
    document.querySelector('.global-video-control').classList.remove('global-video-control-max-z-index');
  };
  this.removeAttribute("open"),
  removeTrapFocus(e ? this.openedBy : null),
  window.pauseAllMedia(),
  document.querySelector("body > quick-add-modal[open]") || (document.documentElement.classList.remove("no-scroll"), document.body.dispatchEvent(new CustomEvent("modalClosed")));
  document.querySelector("body > shipping-policy-modal[open]") || document.documentElement.classList.remove("no-scroll");

  // Ensures that PDP mobile carousel is on correct image once the zoom modal is closed
  if (this.classList.contains('product-media-modal') && document.body.clientWidth <= 575 && document.querySelector('.product__info-container').getAttribute('data-product-variant-thumbnail')) {
    const modalContent = this.querySelector('.product-media-modal__content')
    const modalSwiper = modalContent.closest('.swiper').swiper
    const modalContentPdp = document.querySelector('.product__media-list').swiper
    const curIndex = modalSwiper.activeIndex
    setTimeout(() => {
        modalContentPdp.slideTo(curIndex, 0);
    }, 10);
  }

  e = document.querySelector(".product-media-modal__content");
  e && e.classList.remove("zoom");
  const other = document.getElementById('MainContent')
  if (e) e.swiper.zoom.out();
  other.focus();
}
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
constructor() {
  super();
  const t = this.querySelector("button");
  t &&
      t.addEventListener("click", () => {
          var e = document.querySelector(this.getAttribute("data-modal"));
          e && e.show(t);
      });
}
setOpener() {
const { t } = this.props;
t.addEventListener("click", () => {
  var e = document.querySelector(this.getAttribute("data-modal"));
  e && e.show(t);
});
}
}
customElements.define("modal-opener", ModalOpener);
class ModalOpenerQuickView extends HTMLElement {
constructor() {
    super();
    const t = this.querySelector("button");
    t &&
        t.addEventListener("click", () => {
            const e = document.createElement("quick-add-modal");
            (e.id = t.dataset.modalId),
                (e.className = t.dataset.modalClass),
                (e.innerHTML = `
            <div role="dialog" data-scroll-lock-scrollable aria-label="Choose options for ${t.dataset.modalAriaLabel}" aria-modal="true" class="quick-add-modal__content global-settings-popup js-mobile-swipe js-mobile-swipe-down"><div class="quick-add-modal__control js-mobile-swipe-control"><svg width="38" height="3" viewBox="0 0 38 3" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-mobile-swipe"><rect width="38" height="3" rx="1.5" fill="currentColor"/></svg></div><button id="ModalClose-${t.dataset.productId}" type="button" class="quick-add-modal__toggle modal-close-button" aria-label="Close" tabindex="-1"><svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99989 9.31163L2.29175 15.0198L0.980116 13.7081L6.68826 8L0.980116 2.29186L2.29175 0.980222L7.99989 6.68837L13.708 0.980222L15.0197 2.29186L9.31153 8L15.0197 13.7081L13.708 15.0198L7.99989 9.31163Z" fill="currentColor"/></svg></button><div class="quick-add-modal__content-wrapper"><div id="QuickAddInfo-${t.dataset.productId}" class="quick-add-modal__content-info"></div></div></div>
        `),
                (e.moved = !0),
                (e.modalContent = e.querySelector('[id^="QuickAddInfo-"]')),
                (e.closeButton = e.querySelector('[id^="ModalClose-"]')),
                e.closeButton?.addEventListener("click", () => e.hide(!1)),
                new SwipeMobile(e.querySelector(".js-mobile-swipe"), "down", 160, 400, () => e.hide(!0)),
                document.body.append(e),
                e.show(t);
        });
}
}
customElements.define("modal-opener-quick-view", ModalOpenerQuickView);
class DeferredMedia extends HTMLElement {
constructor() {
    super();
    var e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", () => this.loadContent(!0));
}
loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
        var t = this.querySelector("template");
        if (t && t.content && t.content.firstElementChild) {
            var i = document.createElement("div");
            i.appendChild(t.content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            const s = this.appendChild(i.firstElementChild);
            s instanceof HTMLVideoElement
                ? s.addEventListener("play", () => window.pauseAllMedia(s))
                : s instanceof HTMLIFrameElement
                ? (t = s.src) && t.includes("youtube.com")
                    ? s.addEventListener("load", () => {
                          s.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*"), s.parentElement.addEventListener("click", () => window.pauseAllMedia(s));
                      })
                    : t &&
                      t.includes("vimeo.com") &&
                      s.addEventListener("load", () => {
                          new Vimeo.Player(s).on("play", () => window.pauseAllMedia(s)), s.parentElement.addEventListener("click", () => window.pauseAllMedia(s));
                      })
                : "model-viewer" === s.tagName.toLowerCase()
                ? s.addEventListener("load", () => {
                      window.pauseAllMedia(s);
                  })
                : console.error("Unsupported media element or HTMLModelViewerElement is null"),
                e && (s.focus(), s instanceof HTMLVideoElement) && s.autoplay && s.play().catch(console.error);
        } else console.error("Template or its content is missing.");
    }
}
}
customElements.define("deferred-media", DeferredMedia);
class VariantSelects extends HTMLElement {
constructor() {
    super();
    this.productInfoContainer = document.querySelector('.product__info-container');
    this.variantThumbEnabled = this.productInfoContainer.getAttribute('data-product-variant-thumbnail') === 'true';
    this.thumbnailNavImages = document.querySelectorAll('.product__variant-thumbnail-nav-container .product__variant-thumbnail-nav--image')
    this.mediaList = document.querySelector(".product__media-list")

    this.addEventListener("change", this.onVariantChange);

    if (this.querySelector('.select__select')) {
        this.varSelector = this.querySelector('.select__select');
        this.firstRunDone = true;
    }

    // Ensures the images are in the correct order from the very start
    document.addEventListener("DOMContentLoaded", () => {
        if (this.variantThumbEnabled) {
            thumbnailImages.forEach(variant => {
                this.currentVariant && parseInt(this.currentVariant.id, 10)  === parseInt(variant.variantId, 10) ? this.currentVariant.thumbnailImages = variant.variantThumbnailImages : ''
            })
        }
        this.onVariantChange();
        this.handleThumbnailClick()
    });
}

// Logic for thumbnails changing with variant dropdown selector
handleThumbnailChange() {
    const thumbnailImages = document.querySelectorAll('.product__variant-thumbnail--image')

    let currentVarId = this.currentVariant?.id
    if (currentVarId === undefined && this.querySelector('.select__select').value !== 'select-option') {
        const currentValue = this.querySelector('.select__select').value
        const currentValueId = document.querySelector(`[data-variant-title-status="${currentValue}"]`) && document.querySelector(`[data-variant-title-status="${currentValue}"]`).dataset.variantId
        currentVarId = currentValueId
    }

    thumbnailImages.forEach(image =>  {
        const thummbnailVariantId = image.getAttribute('data-variant-id')
        if (currentVarId) {
            if (parseInt(thummbnailVariantId, 10) === parseInt(currentVarId, 10)) {
                image.classList.add('active')
            } else {
                image.classList.remove('active')
            }
        }
    })
}

updateThumbnailNav(navImages, target, isThumbnail, value) {
    navImages.forEach(container => {
        const variantId = container.querySelector('img').getAttribute('data-variant-title') === value ? container.querySelector('img').getAttribute('data-variant-id') : null
        const targetThumbnailVarId = isThumbnail && target ? target.closest('.product__variant-thumbnail--image').getAttribute('data-variant-id') : variantId
        const activeThumbnailVarId = container.querySelector('.product__variant-thumbnail-nav--image img').getAttribute('data-variant-id')

        if (targetThumbnailVarId !== activeThumbnailVarId) {
            container.classList.add('hidden')
        } else {
            const activeImageSize = document.querySelector(`.product__variant-thumbnail--image[data-variant-id="${activeThumbnailVarId}"`).getAttribute('data-variant-model-height')
            const thumbnailSize = document.querySelectorAll('.product__variant-thumbnail-nav--size')
            thumbnailSize.forEach(sizeContainer => {
                sizeContainer.innerText = activeImageSize
            })
            container.classList.remove('hidden')
        }
    })

    // Checks if the selected variant has no variant images attached
    if (!!document.querySelector('.product__variant-thumbnail-nav--image:not(.hidden)') === false) {
        // If a variant with no variant images has been selected, it will revert the accordion size text back to 'Select Size'
        const thumbnailSize = document.querySelectorAll('.product__variant-thumbnail-nav--size')
        const selectSizeText = document.querySelector('.select__select option[data-disabled-option]')?.innerText.trim().replace(/\s+/g, ' ')
        thumbnailSize.forEach(sizeContainer => {
            const unavailableHyphenatedStr = '- ' + window.variantStrings.unavailable
            
            if (!value.includes(unavailableHyphenatedStr)) {
                sizeContainer.innerText = selectSizeText
            }

            // Ensures text/thumbnail is correct on unavailable products
            if (value.includes(unavailableHyphenatedStr)) {
                if (document.querySelector(`[data-variant-title-status="${value}"]`) !== null) {
                    const thumbnailVarId = parseInt(document.querySelector(`[data-variant-title-status="${value}"]`).dataset.variantId)
                    const activeImageSize = document.querySelector(`.product__variant-thumbnail--image[data-variant-id="${thumbnailVarId}"`).getAttribute('data-variant-model-height')
    
                    // Fixes accordion text when variant unavailable
                    sizeContainer.innerText = activeImageSize
    
                    // Fixes accordion image when variant unavailable
                    const thumbnailImage = sizeContainer.closest('.product__variant-thumbnail-nav-container').querySelector(`[data-variant-title-status="${value}"]`)
                    if (thumbnailImage) {
                        thumbnailImage.parentElement.classList.remove('hidden')
                    }
                } else {
                    // When no variant thumbnail detected, sets accordion text to 'Select Size'
                    sizeContainer.innerText = selectSizeText

                    // Makes sure no active thumbnails are present from a previous variant selection
                    const variantThumbnailImages = document.querySelectorAll('.product__variant-thumbnail--image')
                    variantThumbnailImages.forEach(image => {
                        image.classList.remove('active')
                    })
                }
            }
        })

        // Hides the previous variant images if the newly selected variant has no variant images attached
        document.querySelectorAll('.product__media-item:not([data-media-pos])').forEach(el => el.classList.add('hidden'));
    }
}

handleThumbnailClick() {
    const variantThumbnails = document.querySelectorAll('.product__variant-thumbnail')
    const variantThumbnailImages = document.querySelectorAll('.product__variant-thumbnail--image')
    const thumbnails = document.querySelectorAll('.product__variant-thumbnail')
    const thumbnailSize = document.querySelectorAll('.product__variant-thumbnail-nav--size')

    variantThumbnails.forEach(thumbnail => {
        const thummbnailVariantId = thumbnail.querySelector('.product__variant-thumbnail--image').getAttribute('data-variant-id')

        thumbnail.addEventListener('click', (event) => {
            this.updateURL(parseInt(thummbnailVariantId))

            thumbnailSize.forEach(container => {
                container.innerText = thumbnail.querySelector('.product__variant-thumbnail--image').getAttribute('data-variant-model-height')
            })

            variantThumbnailImages.forEach(image => {
                image.classList.remove('active')
            })
            
            this.updateThumbnailNav(this.thumbnailNavImages, event.target, true)
            event.target.closest('.product__variant-thumbnail--image') && event.target.closest('.product__variant-thumbnail--image').classList.add('active')
        })
    })

    // Tie thumbnail click to variant selector dropdown
    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
            const value = thumbnail.dataset.value
            const variantSelectorRadio = document.querySelector(`input[name="option-2"][value="${value}"]`)
            const variantSelectorDropdown = document.querySelector('.select__select')
        
            if (variantSelectorRadio) {
                variantSelectorRadio.checked = true
                variantSelectorRadio.dispatchEvent(new Event('change', { bubbles: true }))

                const unavailableStr = ' - ' + window.variantStrings.unavailable
                // update select dropdown
                variantSelectorDropdown.value = value || unavailableStr.toLowerCase()
                if (variantSelectorDropdown.value === '') {
                    variantSelectorDropdown.value = value + unavailableStr
                }
                variantSelectorDropdown.dispatchEvent(new Event('change', { bubbles: true }))
            
                thumbnails.forEach(e => e.classList.remove('active'))
                thumbnail.classList.add('active')
        }
        })
    })
}

// Function needs fixing, getCurrentVariant is breaking image order change functionality
onVariantChange() {
    this.updateOptions(),
    this.updateMasterId(),
    this.handleThumbnailChange(),
    this.toggleAddButton(!0, "", !1),
    this.updatePickupAvailability(),
    this.updateVariantStatuses(),
    this.optionSelects = this.querySelectorAll('select[name^="option"]'),
    this.variantInput = this.closest('.product__info-container').querySelector('[name="id"]'),
    this.productHandle = this.variantInput.dataset.productHandle,
    this.currentProductData = window.productVariantData[this.productHandle],
    this.variantOptionsMap = this.currentProductData.variantOptionsMap,
    this.getCurrentVariant(),
    this.updatedVariant = this.getCurrentVariant()

    if (this.variantThumbEnabled) {
        // Ensures unavailable variants still have this.currentVariant when this.variantThumbEnabled enabled
        // Also allows unavailable variants to have product images show when selected
        if (this.updatedVariant && this.currentVariant === undefined) {
            const updatedId = Number(this.updatedVariant.id)
            const matchedVariant = this.getVariantData().find(variant => Number(variant.id) === updatedId)
            this.currentVariant = matchedVariant
        }

        let currentVarFeaturedMedia = this.currentVariant?.featured_media
        const variantDropdown = document.querySelector('.product-form__controls-group .select__select')

        variantDropdown.addEventListener('change', (event) => {
            this.updateThumbnailNav(this.thumbnailNavImages, event.target, null, event.target.value)
        })
        
        const productInfoContainer = this.closest('.product__info-container')
        // Checks if variant thumbnails exists before applying the following logic - which prevents breaking variant selection when no variant thumbnails present
        // Second part checks if user is in quick view, for which this feature is currently unsupported so it will only run if false
        if (productInfoContainer.querySelector('.product__variant-thumbnail-wrapper') && !productInfoContainer.id.includes('quickadd')) {
            // Logic to show/hide popup swiper gallery images based on which variant is selected OR if any variant is selected at all
            // Get modal Content
            const modalContent = document.querySelector('.product-media-modal__content')
            // Get swiper carousel
            const modalSwiper = modalContent.closest('.swiper')
            // Hide/display modal images
            const modalImages = modalContent.querySelectorAll('.swiper-slide')
            Array.from(modalImages).forEach(slide => {
                const slideId = slide.getAttribute("data-variant-id")
                if (this.updatedVariant) {
                    // Hides/shows the relevant images in the popup gallery IF a variant is selected
                    if (slideId != null && slideId !== this.updatedVariant.id) {
                        slide.style.display = "none"
                    } else {
                    slide.style.display = "block" 
                    }
                } else {
                    // Hides/shows the relevant images in the popup gallery IF no variant is selected 
                    if (slideId !== null) {
                        slide.style.display = "none"
                    } else {
                    slide.style.display = "block" 
                    }
                }
            });
            // Update/adjust swiper carousel
            modalSwiper.swiper.update()

            // Updates mobile PDP slides
            if (document.body.clientWidth <= 575) {
                const swiperContent = productInfoContainer.parentElement.querySelector('.product__main');
                const swiperModule = swiperContent.querySelector('.swiper')

                // Async + mutationObserver to make sure swiper only updates after variant images in the swiper element have been updated
                async function isVariantImagesUpdated() {
                    await new Promise(r => new MutationObserver((m,o)=>(o.disconnect(),r(m)))
                    .observe(swiperModule,{attributes:true,childList:true,characterData:true,subtree:true}));
                    swiperModule.swiper.update()
                    swiperModule.swiper.slideTo(0, 0)
                }
                isVariantImagesUpdated();
            }

        } else if (productInfoContainer.id.includes('quickadd')) {
            // Logic which updates the swiper gallery in quickview so that it has the correct number of slides
            const swiperContent = productInfoContainer.parentElement.querySelector('.product__main');
            const swiperModule = swiperContent.querySelector('.swiper')
            swiperModule.swiper.slideTo(0, 0)

            // Async + mutationObserver to make sure swiper only updates after variant images in the swiper element have been updated
            async function isVariantImagesUpdated() {
                await new Promise(r => new MutationObserver((m,o)=>(o.disconnect(),r(m)))
                .observe(swiperModule,{attributes:true,childList:true,characterData:true,subtree:true}));
                swiperModule.swiper.update()
            }
            isVariantImagesUpdated();
        }
        
        const desktopThumbnailWrapper = document.querySelector('.product__variant-thumbnail-wrapper-desktop');
        const mobileThumbnailWrapper = document.querySelector('.product__variant-thumbnail-wrapper-mobile');
        
        // Ensures desktop variant thumbnail accordion opens automatically when there's an active variant
        if (desktopThumbnailWrapper && desktopThumbnailWrapper.querySelector('section')) {
            const desktopThumbnailContainer = desktopThumbnailWrapper.querySelector('section');
            const desktopAccordionBody = desktopThumbnailContainer.querySelector('.product__variant-thumbnails-container')

            if (desktopThumbnailContainer.style.display === 'none' && desktopAccordionBody.querySelector('.active')) {
                desktopThumbnailWrapper.querySelector('.accordion__header').click();
            }
        }

        // Ensures mobile variant thumbnail accordion opens automatically when there's an active variant
        if (mobileThumbnailWrapper && mobileThumbnailWrapper.querySelector('section')) {
            const mobileThumbnailContainer = mobileThumbnailWrapper.querySelector('section');
            const mobileAccordionBody = mobileThumbnailContainer.querySelector('.product__variant-thumbnails-container')

            if (mobileThumbnailContainer.style.display === 'none' && mobileAccordionBody.querySelector('.active')) {
                mobileThumbnailWrapper.querySelector('.accordion__header').click();
            }
        }

        // Find the media item (item with product-media__item class within swiper-wrapper class) associated with the current selected variant
        const currentThumbMediaItem = Array.from(this.mediaList.querySelectorAll('[data-media-id]')).find(mediaItem => {
            return this.currentVariant && this.currentVariant.id === parseInt(mediaItem.getAttribute('data-thumbnail-variant-id'))
        })

        // Get the media ID from aobve media item and build javascript object in the structure of this.currentVariant?.featured_media
        // this.currentVariant?.featured_media is passed as argument in this.updateMedia, which handles PDP image display
        const currentVarThumbMediaId = currentThumbMediaItem && currentThumbMediaItem.dataset.mediaId
        const metafieldImg = {
            preview_image: {
                src: null
            }
        }

        if (currentThumbMediaItem) {
            metafieldImg.alt = currentThumbMediaItem.querySelector('.product__media img').alt
            metafieldImg.id = parseInt(currentVarThumbMediaId.split('__main-')[1])
            metafieldImg.preview_image.src = currentThumbMediaItem.querySelector('.product__media img').src
            currentVarFeaturedMedia = metafieldImg
        
            this.currentVariant && !this.isSingleVariantUnavailable()
            ? (currentVarFeaturedMedia && this.updateMedia(this.dataset.section + "-" + currentVarFeaturedMedia.id, currentVarFeaturedMedia), this.updateURL(), this.updateVariantInput(), this.renderProductInfo())
            : (this.toggleAddButton(!0, "", !0), this.setUnavailable(),
            this.renderProductInfo());
        } else {
            this.currentVariant && !this.isSingleVariantUnavailable()
            ? (this.currentVariant?.featured_media && this.updateMediaOnVariantThumbDisabled(this.dataset.section + "-" + this.currentVariant.featured_media.id), this.updateURL(), this.updateVariantInput(), this.renderProductInfo())
            : (this.toggleAddButton(!0, "", !0), this.setUnavailable(),
            this.renderProductInfo());
        }
    } else {
        this.currentVariant && !this.isSingleVariantUnavailable()
            ? (this.currentVariant?.featured_media && this.updateMediaOnVariantThumbDisabled(this.dataset.section + "-" + this.currentVariant.featured_media.id), this.updateURL(), this.updateVariantInput(), this.renderProductInfo())
            : (this.toggleAddButton(!0, "", !0), this.setUnavailable(),
            this.renderProductInfo());
    }
}

getCurrentVariant() {
  const selectedOptions = Array.from(this.optionSelects).map((select) => {
    let selectValue = select.value;

    // Removes the unnecessary ' - Unavailable' string on unavailable items to make sure the true value is passed through
    if (selectValue.includes(window.variantStrings.unavailable)) {
        const unavailableStr = ' - ' + window.variantStrings.unavailable;
        selectValue = selectValue.replace(unavailableStr, '');
    }

    return selectValue.trim();
  });

  const optionKey = selectedOptions.join(' // ');
  // Find variant ID from our map
  const variantId = this.variantOptionsMap[optionKey];
  const variantData = window.productVariantData[this.productHandle].variantData;
  if (variantId) {
    return {
      id: variantId,
      data: variantData[variantId]
    };
  }
  return null;
}

isSingleVariantUnavailable() {
    const availabilityData = document.querySelector('.umg-product-properties input[name="properties[_bundles_products_availability]"]');
    let singleVariantUnavailable
    if (availabilityData) {
        const productsAvailability = JSON.parse(availabilityData.value);
        singleVariantUnavailable = productsAvailability.find(data => data.singleVariant === true && data.available === false);
    }
    return !!singleVariantUnavailable
}
updateOptions() {
    var e = Array.from(this.querySelectorAll(".js-radio-colors"));
    this.options = Array.from(this.querySelectorAll("select"), (e) => e.value).concat(e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value));
}
updateMasterId() {
    (this.variantData || this.querySelector('[type="application/json"]')) &&
        (this.currentVariant = this.getVariantData().find((e) => (this.options.sort(), e.options.sort(), !e.options.map((e, t) => this.options[t] === e).includes(!1))));
}
isHidden(e) {
    e = window.getComputedStyle(e);
    return "none" === e.display || "hidden" === e.visibility;
}
updateMediaOnVariantThumbDisabled(e) {
    var t;
    this.currentVariant &&
        this.currentVariant?.featured_media &&
        ((t = document.querySelector(`[data-section="main-${this.dataset.section}"]`)),
        (this.mediaList = t.querySelector(".product__media-list")),
        (t = this.mediaList.querySelector(`[data-media-id="${e}"]`)),
        this.mediaList.querySelectorAll("[data-media-id]").forEach((e) => {
            e.classList.remove("active");
        }),
        t && t.classList.add("active"),
        document.querySelectorAll(".product__media-wrapper").forEach((e) => {
            var t;
            if (window.innerWidth >= 576) {
                this.isHidden(e) ||
                    ((t = e.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`)),
                    e.querySelector(".product__media-list") && e.querySelector(".product__media-list").swiper);
            } else {
                // MOBILE THUMBNAIL BEHAVIOR
                this.isHidden(e) ||
                    ((t = e.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`)),
                    e.querySelector(".product__media-list") && e.querySelector(".product__media-list").swiper && e.querySelector(".product__media-list").swiper.slideTo(e.querySelector(".product__media-list ").swiper.slides.indexOf(t)));

            };
        }));
        document.querySelectorAll(`[data-media-id]`).forEach((e) => {
            e.classList.remove("active");
        });
        
    if (window.innerWidth >= 576) {
        let selectedVariantImage = null;
        let unselectedVariantImages = [];
        let normalImages = [];
        let orderedImages = [];

        if (this.currentVariant && this.currentVariant?.featured_media) {
            // Get the media list wrapper
            const mediaListWrapper = document.querySelector(`[data-section="main-${this.dataset.section}"] .product__media-list .swiper-wrapper`);

            // Get the submedia list wrapper (when 'Slider with previews' is enabled)
            const mediaSublistWrapper = document.querySelector(`[data-section="main-${this.dataset.section}"] .product__media-sublist .swiper-wrapper`);

            if (mediaListWrapper) {
                // Get all unselected variant images (selectedVariantImage will be removed further down)
                unselectedVariantImages = Array.from(mediaListWrapper.querySelectorAll(".product__media-item--variant"));

                // Find the currently selected variant's image
                if (this.varSelector && this.varSelector.querySelector('option[data-disabled-option]') === null) {
                    selectedVariantImage = unselectedVariantImages.find((item) =>
                        item.getAttribute("data-media-id")?.includes(this.currentVariant.featured_media.id)
                    );
                } else {
                    if (this.firstRunDone === true) {
                        selectedVariantImage = unselectedVariantImages.find((item) =>
                            item.getAttribute("data-media-id")?.includes(this.currentVariant.featured_media.id)
                        );
                    } else {
                        this.firstRunDone = true;
                        selectedVariantImage = mediaListWrapper.querySelectorAll(".product__media-item")[0];    
                    }
                }

                // Get all normal media images
                normalImages = Array.from(mediaListWrapper.querySelectorAll(".product__media-item"));

                // Add sorting logic for normal media images
                normalImages.sort((a, b) => {
                    const posA = parseInt(a.getAttribute("data-media-pos"), 10) || 0;
                    const posB = parseInt(b.getAttribute("data-media-pos"), 10) || 0;
                    return posA - posB;
                });

                 // Remove the selected variant image from the normalImages array
                if (selectedVariantImage) {
                    normalImages = normalImages.filter((item) => item !== selectedVariantImage);
                }

                // Build the orderedImages array
                orderedImages = [
                    selectedVariantImage, // First image: Selected variant
                    ...normalImages, // Second set: Normal media images
                ];

                // Clear existing mediaList and append reordered images
                mediaListWrapper.innerHTML = ""; // Clear existing children
                orderedImages.forEach((image) => {
                    mediaListWrapper.appendChild(image); // Append in correct order
                });

                // Force Swiper to update after DOM changes
                document.querySelectorAll(".product__media-wrapper").forEach((e) => {
                    var t;
                    var t_index;
                    this.isHidden(e) ||
                        ((t = selectedVariantImage)), 
                        ((t_index = ([...document.querySelector('.swiper-wrapper').children].indexOf(selectedVariantImage)))),
                        (e.querySelector(".product__media-list") && e.querySelector(".product__media-list").swiper && e.querySelector(".product__media-list").swiper.slideTo(e.querySelector(".product__media-list ").swiper.slides.indexOf(t_index)));
                });

                if (mediaSublistWrapper) {
                    let sublistImages = Array.from(mediaSublistWrapper.querySelectorAll(".product__media-subitem"));
                
                    // Reorder sublist images to match orderedImages order
                    let orderedSublist = orderedImages.map(img => 
                        sublistImages.find(sub => sub.getAttribute("data-media-pos") === img.getAttribute("data-media-pos"))
                    ).filter(Boolean); // Removes any unmatched items
                
                    // Clear and append in the correct order
                    mediaSublistWrapper.innerHTML = "";
                    orderedSublist.forEach(img => mediaSublistWrapper.appendChild(img));

                    // Removes the active class (which increases opacity to 100%) from any items if previously added
                    mediaSublistWrapper.querySelectorAll(".gcom-swiper-slide-thumb-active").forEach(el => el.classList.remove("gcom-swiper-slide-thumb-active"));

                    // Add the active class to first item (which increases opacity to 100%)
                    mediaSublistWrapper.children[0]?.classList.add("gcom-swiper-slide-thumb-active");
                }
            }
        }
    }
}
updateMedia(e, currentVarFeaturedMedia) {
        var t;
        this.currentVariant &&
            currentVarFeaturedMedia &&
            ((t = document.querySelector(`[data-section="main-${this.dataset.section}"]`)),
            (this.mediaList = t.querySelector(".product__media-list")),
            (t = this.mediaList.querySelector(`[data-media-id="${e}"]`)),
            this.mediaList.querySelectorAll("[data-media-id]").forEach((e) => {
                e.classList.remove("active");
            }),
            t && t.classList.add("active"),
            document.querySelectorAll(".product__media-wrapper").forEach((e) => {
                var t;
                if (window.innerWidth >= 576) {
                    this.isHidden(e) ||
                        ((t = e.querySelector(`[data-media-id="${this.dataset.section}-${currentVarFeaturedMedia.id}"]`)),
                        e.querySelector(".product__media-list") && e.querySelector(".product__media-list").swiper);
                } else {
                    // MOBILE THUMBNAIL BEHAVIOR
                    this.isHidden(e) ||
                        ((t = e.querySelector(`[data-media-id="${this.dataset.section}-${currentVarFeaturedMedia.id}"]`)),
                        e.querySelector(".product__media-list") && e.querySelector(".product__media-list").swiper && e.querySelector(".product__media-list").swiper.slideTo(e.querySelector(".product__media-list ").swiper.slides.indexOf(t)));

                };
            }));
            document.querySelectorAll(`[data-media-id]`).forEach((e) => {
                e.classList.remove("active");
            });


        var widthCutoff = 576;
        if (this.variantThumbEnabled) {
            widthCutoff = 1;
        }
            
        if (window.innerWidth >= widthCutoff) {
            let selectedVariantImage = null;
            let unselectedVariantImages = [];
            let normalImages = [];
            let orderedImages = [];

            if (this.currentVariant && currentVarFeaturedMedia) {
                // Get the media list wrapper
                const mediaListWrapper = document.querySelector(`[data-section="main-${this.dataset.section}"] .product__media-list .swiper-wrapper`);

                // Get the submedia list wrapper (when 'Slider with previews' is enabled)
                const mediaSublistWrapper = document.querySelector(`[data-section="main-${this.dataset.section}"] .product__media-sublist .swiper-wrapper`);

                if (mediaListWrapper) {
                    // Get all unselected variant images (selectedVariantImage will be removed further down)
                    unselectedVariantImages = Array.from(mediaListWrapper.querySelectorAll(".product__media-item--variant"));
                    // Find the currently selected variant's image
                    if (this.varSelector && this.varSelector.querySelector('option[data-disabled-option]') === null) {
                        selectedVariantImage = unselectedVariantImages.find((item) => {
                            item.getAttribute("data-media-id")?.includes(currentVarFeaturedMedia.id)
                            }
                        );
                    } else {
                        if (this.firstRunDone === true) {
                            selectedVariantImage = unselectedVariantImages.find((item) => {
                                item.getAttribute("data-media-id")?.includes(currentVarFeaturedMedia.id)
                            }
                            );
                        } else {
                            this.firstRunDone = true;
                            selectedVariantImage = mediaListWrapper.querySelectorAll(".product__media-item")[0];    
                        }
                    }

                    // Get all normal media images
                    normalImages = Array.from(mediaListWrapper.querySelectorAll(".product__media-item"));

                    // Add sorting logic for normal media images
                    normalImages.sort((a, b) => {
                        const posA = parseInt(a.getAttribute("data-media-pos"), 10) || 0;
                        const posB = parseInt(b.getAttribute("data-media-pos"), 10) || 0;
                        return posA - posB;
                    });

                    // Remove the selected variant image from the normalImages array
                    if (selectedVariantImage) {
                        normalImages = normalImages.filter((item) => item !== selectedVariantImage);
                    }

                    // Build the orderedImages array
                    orderedImages = [
                        selectedVariantImage, // First image: Selected variant
                        ...normalImages, // Second set: Normal media images
                    ];

                    // Clear existing mediaList and append reordered images
                    mediaListWrapper.innerHTML = ""; // Clear existing children
                    orderedImages.forEach((image) => {
                        if (this.variantThumbEnabled) {
                            if (image !== undefined) {
                                const mediaItem = image.getAttribute('data-media-id').includes(currentVarFeaturedMedia.id)
                                const hasThumbnailVariant = image.hasAttribute('data-thumbnail-variant-id')
                                const thumbnailVarId = parseInt(image.getAttribute('data-thumbnail-variant-id'))
                                
                                if (hasThumbnailVariant) {
                                    image.classList.add('hidden')
                                }
                                
                                mediaItem && image.classList.remove('hidden')
                                thumbnailVarId === this.currentVariant.id && image.classList.remove('hidden')
                                mediaListWrapper.appendChild(image); // Append in correct order
                            }
                        } else {
                            if (image !== undefined) {
                                mediaListWrapper.appendChild(image); // Append in correct order
                            }
                        }
                    });

                    // Force Swiper to update after DOM changes
                    document.querySelectorAll(".product__media-wrapper").forEach((e) => {
                        var t;
                        var t_index;
                        this.isHidden(e) ||
                            ((t = selectedVariantImage)), 
                            ((t_index = ([...document.querySelector('.swiper-wrapper').children].indexOf(selectedVariantImage)))),
                            (e.querySelector(".product__media-list") && e.querySelector(".product__media-list").swiper && e.querySelector(".product__media-list").swiper.slideTo(e.querySelector(".product__media-list ").swiper.slides.indexOf(t_index)));
                    });

                    if (mediaSublistWrapper) {
                        let sublistImages = Array.from(mediaSublistWrapper.querySelectorAll(".product__media-subitem"));
                    
                        // Reorder sublist images to match orderedImages order
                        let orderedSublist = orderedImages.map(img => 
                            sublistImages.find(sub => sub.getAttribute("data-media-pos") === img.getAttribute("data-media-pos"))
                        ).filter(Boolean); // Removes any unmatched items
                    
                        // Clear and append in the correct order
                        mediaSublistWrapper.innerHTML = "";
                        orderedSublist.forEach(img => mediaSublistWrapper.appendChild(img));

                        // Removes the active class (which increases opacity to 100%) from any items if previously added
                        mediaSublistWrapper.querySelectorAll(".gcom-swiper-slide-thumb-active").forEach(el => el.classList.remove("gcom-swiper-slide-thumb-active"));

                        // Add the active class to first item (which increases opacity to 100%)
                        mediaSublistWrapper.children[0]?.classList.add("gcom-swiper-slide-thumb-active");
                    }
                }
            }
        }
}

updateURL(variantId) {
    this.classList.contains("featured-product-radios") || (this.currentVariant && this.dataset.updateUrl !== "false" && window.history.replaceState({}, "", this.dataset.url + "?variant=" + (variantId || this.currentVariant.id)));
}

updateVariantInput() {
    let parent = this.closest('.product__info-container');
    (this.dataset.index
        ? parent.querySelectorAll(`#product-form-${this.dataset.section}-${this.dataset.index}, #product-form-installment-${this.dataset.section}-` + this.dataset.index)
        : parent.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-` + this.dataset.section)
    ).forEach((e) => {
        const variantHidden = e.querySelector('[name="id"]');
        const variant = parent.querySelector('quantity-input');
        
        setTimeout(() => {
          const variantId = this.updatedVariant.id;
          const variantData = window.productVariantData[this.productHandle].variantData;
          if (variantId && variantData[variantId]) {
            const qtyInput = parent.querySelector('[name="quantity"]');
            if (qtyInput) {
              qtyInput.dataset.inventory = variantData[variantId].inventory;
              qtyInput.dataset.purchaseLimit = variantData[variantId].purchase_limit;
              qtyInput.dataset.continueSelling = variantData[variantId].inventory_policy;
            }
          }
          variant.checkPurchaseLimit(true);
        }, 300);

        (variantHidden.value = this.currentVariant.id),
        (variant.dataset.variantId = this.currentVariant.id),
        e.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
}
updateVariantStatuses() {
    const n = this.variantData.filter((e) => this.querySelector(":checked").value === e.option1),
        o = [...this.querySelectorAll(".product-form__controls")];
    o.forEach((e, t) => {
        if (0 !== t) {
            e = [...e.querySelectorAll('input[type="radio"], option')];
            const s = o[t - 1].querySelector(":checked").value;
            var i = n.filter((e) => e.available && e["option" + t] === s).map((e) => e["option" + (t + 1)]);
            this.setInputAvailability(e, i);
        }
    });
}
setInputAvailability(e, t) {
    e.forEach((e) => {
        t.includes(e.getAttribute("value"))
            ? "OPTION" === e.tagName
                ? (e.innerText = 
                    e.getAttribute("data-disabled-option") === "true"
                        ? e.innerText
                        : e.getAttribute("value"))
                : "INPUT" === e.tagName && e.classList.remove("disabled")
            : "OPTION" === e.tagName
                ? (e.innerText =
                    e.getAttribute("data-disabled-option") === "true"
                        ? e.innerText
                        : e.getAttribute("value"))
            : "INPUT" === e.tagName && e.classList.add("disabled");
    });
}
updatePickupAvailability() {
    var e = document.querySelector("pickup-availability");
    e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
}
renderProductInfo() {
  if (this.updatedVariant) {
    const c = this.updatedVariant.id;
    const variantData = window.productVariantData[this.productHandle].variantData;
    const variantAvailability = variantData[c].availability;
    this.dataset.originalSection || this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.updatedVariant.id}&section_id=` + (this.dataset.originalSection || this.dataset.section))
      .then((e) => e.text())
      .then((e) => {
        var t, i, s, n, o, a, r, l, d, date1, date2, properties1, properties2, qtyInput1, qtyInput2, bis_form1, bis_form2;
        this.updatedVariant.id === c &&
          ((e = new DOMParser().parseFromString(e, "text/html")).querySelector(".featured-product-slideshow-section")
            ? ((a = this.dataset.index),
              (r = document.getElementById(`price-${this.dataset.section}-` + a)),
              (t = e.getElementById(`price-${this.dataset.originalSection || this.dataset.section}-` + a)),
              (date1 = document.getElementById(`date-${this.dataset.section}-` + a)),
              (date2 = e.getElementById(`date-${this.dataset.originalSection || this.dataset.section}-` + a)),
              (properties1 = document.getElementById(`umg-product-properties-${this.dataset.section}-` + a)),
              (properties2 = e.getElementById(`umg-product-properties-${this.dataset.originalSection || this.dataset.section}-` + a)),
              (s = e.getElementById(`Sku-${this.dataset.originalSection || this.dataset.section}-` + a)),
              (i = document.getElementById(`Sku-${this.dataset.section}-` + a)),
              (d = e.getElementById(`Inventory-${this.dataset.originalSection || this.dataset.section}-` + a)),
              (l = document.getElementById(`Inventory-${this.dataset.section}-` + a)),
              (o = e.getElementById(`ColorName-${this.dataset.originalSection || this.dataset.section}-` + a)),
              (n = document.getElementById(`ColorName-${this.dataset.section}-` + a)),
              t && r && (r.innerHTML = t.innerHTML),
              d && l && (l.innerHTML = d.innerHTML),
              s && i && ((i.innerHTML = s.innerHTML), i.classList.toggle("visibility-hidden", s.classList.contains("visibility-hidden"))),
              date1 && date2 && ((date2.innerHTML = date1.innerHTML), date2.classList.toggle("visibility-hidden", date1.classList.contains("visibility-hidden"))),
              o && n && (n.innerHTML = o.innerHTML),
              (r = document.getElementById(`price-${this.dataset.section}-` + a)) && r.classList.remove("visibility-hidden"),
              l && l.classList.toggle("visibility-hidden", "" === d.innerText))
            : ((t = document.getElementById("price-" + this.dataset.section)),
              (i = e.getElementById("price-" + (this.dataset.originalSection || this.dataset.section))),
              (date1 = document.getElementById(`date-${this.dataset.section}`)),
              (date2 = e.getElementById(`date-${this.dataset.originalSection || this.dataset.section}`)),
              (properties1 = document.getElementById(`umg-product-properties-${this.dataset.section}`)),
              (properties2 = e.getElementById(`umg-product-properties-${this.dataset.originalSection || this.dataset.section}`)),
              (s = e.getElementById("Sku-" + (this.dataset.originalSection || this.dataset.section))),
              (n = document.getElementById("Sku-" + this.dataset.section)),
              (o = e.getElementById("Inventory-" + (this.dataset.originalSection || this.dataset.section))),
              (a = document.getElementById("Inventory-" + this.dataset.section)),
              (r = e.getElementById("ColorName-" + (this.dataset.originalSection || this.dataset.section))),
              (l = document.getElementById("ColorName-" + this.dataset.section)),
              i && t && (t.innerHTML = i.innerHTML),
              o && a && (a.innerHTML = o.innerHTML),
              s && n && ((n.innerHTML = s.innerHTML), n.classList.toggle("visibility-hidden", s.classList.contains("visibility-hidden"))),
              date1 && date2 && ((date1.innerHTML = date2.innerHTML), date2.classList.toggle("visibility-hidden", date1.classList.contains("visibility-hidden"))),
              properties1 && properties2 && ((properties1.innerHTML = properties2.innerHTML), properties2.classList.toggle("visibility-hidden", properties1.classList.contains("visibility-hidden"))),
              r && l && (l.innerHTML = r.innerHTML),
              (d = document.getElementById("price-" + this.dataset.section)) && d.classList.remove("visibility-hidden"),
              a && a.classList.toggle("visibility-hidden", "" === o.innerText)),
          this.toggleAddButton(!variantAvailability, window.variantStrings.unavailable));

        qtyInput1 = document.querySelector('.product-form__input > .quantity > .quantity__input')
        qtyInput2 = e.querySelector('.product-form__input > .quantity > .quantity__input')
        qtyInput1 && qtyInput2 && (qtyInput1.dataset.purchaseLimit = qtyInput2.dataset.purchaseLimit)

        // bis form replacement / removal
        var product_form = document.getElementById(`product-form-${this.dataset.section}`)
        bis_form1 = product_form.parentNode.querySelector('.bis__wrapper')
        bis_form2 = e.querySelector('.bis__wrapper')
        // if bis form type is popup and form2 exists, then remove the old modal
        bis_form2 && bis_form2.querySelector('modal-opener') && bis_form1 && bis_form1.querySelector('modal-opener') && document.querySelector(bis_form1.querySelector('modal-opener').dataset.modal).remove()
        // replace form1 or remove bis form based on existence of form2 and child elements
        bis_form1 && bis_form2 ? bis_form1.replaceWith(bis_form2) :
          bis_form2 ? 
            product_form.parentNode.children.length > 1 ? product_form.parentNode.insertBefore(bis_form2, product_form.parentNode.children[1]) :
              product_form.parentNode.append(bis_form2) :
          bis_form1 && bis_form1.remove()

        // bis popup variant selection handler
        // bis popup opener gets brought in from the form replacement
        var bis_popup_opener = document.querySelector('.bis__product-popup.bis__wrapper modal-opener')
        if (bis_popup_opener) {
          // bis popup gets brought in from the form replacement
          var bis_popup = document.querySelector(bis_popup_opener.dataset.modal)
          var bis_popup_form = bis_popup.querySelector('back-in-stock-form')
          var bis_variant_selector = bis_popup.querySelector('.product-parameters select')
          bis_variant_selector.addEventListener('change', (event) => {
            bis_popup_form.setAttribute('data-variant-id', event.target.value)
            bis_popup_form.showForm()
          })
        }
      });
  }
}

toggleAddButton(disableButton = true, buttonText, _unusedParameter) {
    this.disableButton = disableButton
    const productFormId = this.dataset.index
        ? `product-form-${this.dataset.section}-${this.dataset.index}`
        : `product-form-${this.dataset.section}`;
    const productForm = document.getElementById(productFormId);
    const productFormControl = productForm.querySelector('.product-form__buttons');

    const yCoordinate = (productFormControl.getBoundingClientRect().top + window.pageYOffset) - (window.innerHeight / 2 + productFormControl.getBoundingClientRect().height / 2)

    // Prevent submit and scroll into view
    const preventAndScroll = (e) => {
        if (this.disableButton) {
            e.preventDefault();
            window.scrollTo({
                top: yCoordinate,
                behavior: 'smooth'
            });
        }
    }

    if (productForm) {
        const addButtons = productForm.querySelectorAll('[name="add"]');
        const addButtonsTextSpan = productForm.querySelectorAll('[name="add"] > span'); // Or, more robustly: addButton.querySelector('span');

        for (let i = 0; i < addButtons.length; i++) {
            if (addButtons[i] && addButtonsTextSpan[i]) {
                if (disableButton) {
                    if (addButtons[i].classList.contains('product-form__sticky-cta')) {
                        addButtons[i].disabled = false;
                        addButtons[i].addEventListener('click', preventAndScroll)
                    } else {
                        addButtons[i].disabled = true;
                    }

                    if (buttonText) {
                        buttonText = buttonText.trim();
                        const inText = window.variantStrings.in
                        addButtonsTextSpan[i].textContent = buttonText;
                        if (addButtons[i].classList.contains('product-form__sticky-cta')){
                            let customUnavailableString = document.querySelector('[data-unavailable-string]').dataset.unavailableString;
                            let stickyTextString = `${buttonText}`
                            if (this.currentVariant) {
                                stickyTextString = `${buttonText} ${inText} ${this.currentVariant.title}`
                                if (customUnavailableString) {
                                    stickyTextString = `${customUnavailableString} ${inText} ${this.currentVariant.title}`
                                }
                            }
                            addButtonsTextSpan[i].textContent = stickyTextString;
                        }
                    }
                } else {
                    addButtons[i].disabled = false
                    addButtonsTextSpan[i].textContent = window.variantStrings.addToCart;
                }
            }
        }
    }
}

setUnavailable() {
    var unavailableString = window.variantStrings.unavailable;
    const optionPlaceholder = this.options.find(o => o === 'select-option');
    if (!this.isSingleVariantUnavailable() && optionPlaceholder) {
        unavailableString = this.varSelector[0].innerHTML;
    }
    var e = (this.dataset.index ? document.getElementById(`product-form-${this.dataset.section}-` + this.dataset.index) : document.getElementById("product-form-" + this.dataset.section)).querySelector('[name="add"]'),
        t = this.dataset.index ? document.getElementById(`Inventory-${this.dataset.section}-` + this.dataset.index) : document.getElementById("Inventory-" + this.dataset.section),
        i = this.dataset.index ? document.getElementById(`Sku-${this.dataset.section}-` + this.dataset.index) : document.getElementById("Sku-" + this.dataset.section);
    e && (this.toggleAddButton(!0, unavailableString), t && t.classList.add("visibility-hidden"), i) && i.classList.add("visibility-hidden");
}
getVariantData() {
    return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
}
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
constructor() {
    super();
}
setInputAvailability(e, t) {
    e.forEach((e) => {
        t.includes(e.getAttribute("value")) ? e.classList.remove("disabled") : e.classList.add("disabled");
    });
}
updateOptions() {
    var e = Array.from(this.querySelectorAll("fieldset"));
    this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
}
}
customElements.define("variant-radios", VariantRadios);
class PasswordViewer {
constructor() {
    document.querySelectorAll(".field--pass").forEach((e) => {
        const t = e.querySelector("input"),
            i = e.querySelector(".button-pass-visibility"),
            s = e.querySelector(".icon-eye-close"),
            n = e.querySelector(".icon-eye");
        t.addEventListener("input", () => {
            "" !== t.value ? (i.style.display = "block") : (i.style.display = "none");
        }),
            s.addEventListener("click", () => {
                (t.type = "text"), (s.style.display = "none"), (n.style.display = "block");
            }),
            n.addEventListener("click", () => {
                (t.type = "password"), (s.style.display = "block"), (n.style.display = "none");
            });
    });
}
}
class ProductRecommendations extends HTMLElement {
constructor() {
    super(), (this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" })), this.intersectionObserver.observe(this);
}
handleIntersection(e, t) {
    e[0].isIntersecting &&
        (t.unobserve(this),
        this.showLoading(),
        this.loadRecommendations()
            .then((e) => {
                this.updateRecommendations(e), this.checkSwatches(), this.initSliders();
            })
            .catch((e) => {
                console.error("Error loading recommendations:", e);
            })
            .finally(() => {
                this.hideLoading();
            }));
}
showLoading() {
    var e = this.querySelector(".product-recommendations__loading");
    e && (e.classList.add("loading"), (e.style.display = "flex"));
}
hideLoading() {
    var e = this.querySelector(".product-recommendations__loading");
    e && e.classList.remove("loading");
}
async loadRecommendations() {
    var e = await (await fetch(this.dataset.url)).text(),
        t = document.createElement("div");
    return (t.innerHTML = e), t;
}
updateRecommendations(e) {
    (e = e.querySelector("product-recommendations")), e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML), (e = this.querySelector(".product-recommendations__empty"));
    e && (e.style.display = "flex");
}
checkSwatches() {
    document.querySelectorAll(".js-color-swatches-wrapper").forEach((t) => {
        t.querySelectorAll(".js-color-swatches input").forEach((e) => {
            e.addEventListener("click", this.handleSwatchClick.bind(this, t, e));
        });
    });
}
handleSwatchClick(e, t) {
    var i,
        s,
        n,
        o,
        a = e.querySelector(".media--first"),
        r = e.querySelector(".media--second");
    t.checked &&
        a &&
        (e.querySelector(".js-color-swatches-link").setAttribute("href", t.dataset.variantLink),
        (i = e.querySelector('.card__add-to-cart button[name="add"]')),
        (s = e.querySelector('.card__add-to-cart button[name="add"] > span')),
        (n = e.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')),
        (o = e.querySelector('.card__add-to-cart [name="id"]')),
        i && (i.setAttribute("aria-disabled", !1), s && s.classList.remove("hidden"), n && n.classList.add("hidden"), (o.value = t.dataset.variantId)),
        this.updateVariantImages(e, a, r, t.value));
}
async updateVariantImages(e, t, i, s) {
    try {
        var n = e.dataset.url,
            o = await fetch(n);
        if (!o.ok) throw new Error("Network response was not ok");
        var a = await o.json(),
            r = a.variants.find((e) => e.featured_media && e.options.includes(s));
        r && this.replaceImages(e, r, t, i, a.title);
    } catch (e) {
        console.error("There was a problem with the fetch operation:", e);
    }
}
replaceImages(e, t, i, s, n) {
    const o = this.createImageElement(t.featured_media, i.className, i.sizes, n);
    if (o.src !== i.src) {
        let e = !1;
        s && new URL(s.src).pathname === new URL(o.src).pathname && (i.remove(), s.classList.remove("media--second"), s.classList.add("media--first"), (e = !0)),
            e ||
                this.fadeOutImage(i, () => {
                    i.parentNode.replaceChild(o, i), this.fadeInImage(o), s && s.remove();
                });
    }
}
fadeOutImage(e, t) {
    e.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: "ease-in", fill: "forwards" }).onfinish = t;
}
fadeInImage(e) {
    e.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: "ease-in", fill: "forwards" });
}
createImageElement(e, t, i, s) {
    var n = e.preview_image,
        o = new Image(n.width, n.height);
    return (o.className = t), (o.alt = e.alt || s), (o.sizes = i), (o.src = n.src), (o.srcset = this.generateSrcset(n, [165, 360, 533, 720, 940, 1066])), (o.loading = "lazy"), o;
}
generateSrcset(t, e) {
    const i = new URL(t.src);
    return e
        .filter((e) => e <= t.width)
        .map((e) => (i.searchParams.set("width", e.toString()), i.href + ` ${e}w`))
        .join(", ");
}
initSliders() {
    this.initSlider(".js-recommendation-swiper", this.setupRecommendationSlider.bind(this)), this.initSlider(".js-complementary-swiper", this.setupComplementarySlider.bind(this));
}
initSlider(e, t) {
    e = this.querySelector(e);
    e && t(e);
}
setupRecommendationSlider(e) {
    var t = this.querySelector(".product-recommendations__navigation"),
        i = this.querySelector(".product-recommendations__pagination"),
        s = Number(e.dataset.columns),
        n = {
            576: { slidesPerView: Math.max(s - 3, 1), slidesPerGroup: Math.max(s - 3, 1), spaceBetween: 24 },
            750: { slidesPerView: Math.max(s - 2, 1), slidesPerGroup: Math.max(s - 2, 1), spaceBetween: 24 },
            1200: { slidesPerView: Math.max(s - 1, 1), slidesPerGroup: Math.max(s - 1, 1), spaceBetween: 24 },
            1600: { slidesPerView: s, slidesPerGroup: s, spaceBetween: 24 },
        };
    new Swiper(e, {
        slidesPerView: Math.min(s, 2),
        slidesPerGroup: Math.min(s, 2),
        spaceBetween: 8,
        speed: 800,
        navigation: { nextEl: t.querySelector(".swiper-button-next"), prevEl: t.querySelector(".swiper-button-prev") },
        pagination: {
            el: i,
            type: "custom",
            renderCustom: (e, t, i) => {
                let s = "";
                for (let e = 1; e <= i; e++) s += `<span class="swiper-pagination-bullet ${e === t ? "swiper-pagination-bullet-active" : ""}" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                return s;
            },
        },
        breakpoints: n,
    });
}
setupComplementarySlider(e) {
    new Swiper(e, {
        spaceBetween: 8,
        speed: 800,
        navigation: { nextEl: e.querySelector(".swiper-button-next"), prevEl: e.querySelector(".swiper-button-prev") },
        pagination: { el: e.querySelector(".swiper-pagination"), type: "fraction" },
    });
}
}
function formatMoney(e, t = "") {
"string" == typeof e && (e = e.replace(".", ""));
let i = "";
var s = /\{\{\s*(\w+)\s*\}\}/,
    t = t || theme.moneyFormat;
function n(e, t = 2, i = ",", s = ".") {
    return isNaN(e) || null == e ? 0 : (t = (e = (e / 100).toFixed(t)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (t[1] ? s + t[1] : "");
}
switch (t.match(s)[1]) {
    case "amount":
        i = n(e, 2);
        break;
    case "amount_no_decimals":
        i = n(e, 0);
        break;
    case "amount_with_comma_separator":
        i = n(e, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        i = n(e, 0, ".", ",");
}
return t.replace(s, i);
}
customElements.define("product-recommendations", ProductRecommendations),
(function () {
    var e = () => {
        const s = new IntersectionObserver((e) => {
                e.forEach((e) => {
                    var t;
                    e.isIntersecting && !e.target.hasAttribute("data-paused") ? void 0 !== (t = e.target.play()) && t.then((e) => {}).catch((e) => {}) : e.target.pause();
                });
            }),
            i = (e, t) => {
                var i = e.querySelector("source");
                i ? i.src !== t && (t ? ((i.src = t), e.load(), s.unobserve(e), s.observe(e)) : (i.remove(), e.load())) : t && (((i = document.createElement("source")).type = "video/mp4"), (i.src = t), e.append(i));
            },
            t = new ResizeObserver((e) => {
                e.forEach((e) => {
                    var t;
                    575 < document.body.clientWidth ? ((t = e.target.dataset.urlDesktop), i(e.target, t)) : ((t = e.target.dataset.urlMobile), i(e.target, t));
                    const poster = 575 < document.body.clientWidth ? e.target.dataset.posterDesktop : e.target.dataset.posterMobile;
                    if (poster) {
                      e.target.setAttribute("poster", poster);
                    }
                });
            });
        document.querySelectorAll(".js-dynamic-video").forEach((e) => {
            t.observe(e), s.observe(e);
        });
    };
    e(), document.addEventListener("shopify:section:load", e);
})();
class LocalizationForm extends HTMLElement {
constructor() {
    super(),
        (this.elements = { input: this.querySelector('input[name="locale_code"], input[name="country_code"]'), button: this.querySelector("button"), panel: this.querySelector("ul") }),
        this.elements.button.addEventListener("click", this.openSelector.bind(this)),
        this.elements.button.addEventListener("focusout", this.closeSelector.bind(this)),
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
        this.querySelectorAll("a").forEach((e) => e.addEventListener("click", this.onItemClick.bind(this)));
}
hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false"), this.elements.panel.setAttribute("hidden", !0);
}
onContainerKeyUp(e) {
    "ESCAPE" === e.code.toUpperCase() && (this.hidePanel(), this.elements.button.focus());
}
onItemClick(e) {
    e.preventDefault(), (this.elements.input.value = e.currentTarget.dataset.value), this.querySelector("form")?.submit();
}
openSelector() {
    this.elements.button.focus(), this.elements.panel.toggleAttribute("hidden"), this.elements.button.setAttribute("aria-expanded", ("false" === this.elements.button.getAttribute("aria-expanded")).toString());
}
closeSelector(e) {
    this.contains(e.relatedTarget) || this.hidePanel();
}
}
customElements.define("localization-form", LocalizationForm);
class MobileLocalizationForm extends HTMLElement {
constructor() {
    super(),
        (this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector("button.mobile-localization-form__button"),
            buttonBack: this.querySelector("button.mobile-localization-form__back"),
            submenu: this.querySelector(".mobile-localization-form__submenu"),
        }),
        this.elements.button.addEventListener("click", this.openSelector.bind(this)),
        this.elements.buttonBack.addEventListener("click", this.closeSelector.bind(this)),
        this.querySelectorAll("form a").forEach((e) => e.addEventListener("click", this.onItemClick.bind(this)));
}
onItemClick(e) {
    e.preventDefault(), (this.elements.input.value = e.currentTarget.dataset.value), this.querySelector("form")?.submit();
}
openSelector() {
    this.elements.button.setAttribute("aria-expanded", "true"), this.elements.submenu.classList.add("active");
}
closeSelector() {
    this.elements.button.setAttribute("aria-expanded", "false"), this.elements.submenu.classList.remove("active");
}
}
customElements.define("mobile-localization-form", MobileLocalizationForm);
class SwipeMobile {
constructor(e, t = "down", i = 160, s = 400, n = () => {}) {
    (this.element = e),
        (this.control = this.element.querySelector(".js-mobile-swipe-control") || this.element),
        (this.direction = { down: "down" === t, up: "up" === t, right: "right" === t, left: "left" === t }),
        (this.orientation = { vertical: "down" === t || "up" === t, horizontal: "right" === t || "left" === t }),
        (this.treshhold = i),
        (this.closeAnimationTime = s),
        (this.closeCallback = n),
        (this.start = { x: 0, y: 0 }),
        (this.delta = { x: 0, y: 0 }),
        (this.closeTransform = { x: `translateX(${this.direction.right ? "110%" : "-110%"})`, y: `translateY(${this.direction.down ? "110%" : "-110%"})` }),
        (this.startTouch = this.startTouch.bind(this)),
        (this.moveTouch = this.moveTouch.bind(this)),
        (this.endTouch = this.endTouch.bind(this)),
        this.init();
}
close() {
    this.control.removeEventListener("touchmove", this.moveTouch),
        this.control.removeEventListener("touchend", this.endTouch),
        (this.element.style.transform = this.orientation.vertical ? this.closeTransform.y : this.closeTransform.x),
        (this.element.style.transition = `transform ${this.closeAnimationTime}ms`),
        setTimeout(() => {
            (this.element.style.transform = ""), (this.element.style.transition = ""), this.closeCallback();
        }, this.closeAnimationTime);
}
startTouch(e) {
    e.stopPropagation(),
        this.control.addEventListener("touchmove", this.moveTouch, { passive: !0 }),
        this.control.addEventListener("touchend", this.endTouch, { passive: !0 }),
        (this.start.x = e.touches[0].clientX),
        (this.start.y = e.touches[0].clientY),
        (this.element.style.transition = "transform 0ms linear 0ms");
}
moveTouch(e) {
    e.stopPropagation(),
        (this.delta.x = e.touches[0].clientX - this.start.x),
        (this.delta.y = e.touches[0].clientY - this.start.y),
        (this.orientation.vertical && this.direction.down && this.delta.y <= 0) ||
            (this.direction.up && 0 <= this.delta.y) ||
            (this.orientation.horizontal && this.direction.right && this.delta.x <= 0) ||
            (this.direction.left && 0 <= this.delta.x) ||
            ((e = this.orientation.vertical ? `translateY(${this.delta.y}px)` : `translateX(${this.delta.x}px)`), (this.element.style.transform = e));
}
endTouch(e) {
    e.stopPropagation(),
        (this.element.style.transition = ""),
        (this.element.style.transform = ""),
        ((this.orientation.vertical && ((this.direction.down && this.delta.y >= this.treshhold) || (this.direction.up && this.delta.y <= -this.treshhold))) ||
            (this.orientation.horizontal && ((this.direction.right && this.delta.x >= this.treshhold) || (this.direction.left && this.delta.x <= -this.treshhold)))) &&
            this.close(),
        this.reset();
}
reset() {
    (this.start = { x: 0, y: 0 }), (this.delta = { x: 0, y: 0 });
}
init() {
    new ResizeObserver((e) => {
        e.forEach((e) => {
            e.contentRect.width < 576
                ? this.control.addEventListener("touchstart", this.startTouch, { passive: !0 })
                : (this.control.removeEventListener("touchstart", this.startTouch), this.control.removeEventListener("touchmove", this.moveTouch), this.control.removeEventListener("touchend", this.endTouch));
        });
    }).observe(document.documentElement);
}
}

document.querySelectorAll(".js-mobile-swipe").forEach((e) => {
let t;
let i = () => {};
if (e.classList.contains("js-mobile-swipe-up")) t = "up";
else if (e.classList.contains("js-mobile-swipe-down")) t = "down";
else if (e.classList.contains("js-mobile-swipe-right")) t = "right";
else {
    if (!e.classList.contains("js-mobile-swipe-left")) return;
    t = "left";
}
e.classList.contains("popup") &&
    (i = () => {
        e.classList.remove("popup-open"), e.classList.add("popup-already-opened"), document.body.classList.remove("popup-scroll-hidden", "popup-scroll-hidden-mobile");
    }),
    e.classList.contains("banner-products__wrapper") &&
        (i = () => {
            e.closest(".banner-products__inner").classList.remove("active"), document.body.classList.remove("overflow-hidden-products");
        }),
    e.classList.contains("product-drawer__wrapper") &&
        (i = () => {
            e.closest(".product-drawer__inner").classList.remove("active"), document.body.classList.remove("overflow-hidden-products");
        }),
    e.classList.contains("quick-add-modal__content") &&
        (i = () => {
            e.closest("quick-add-modal").hide(!0);
        }),
    e.classList.contains("drawer__inner") &&
        e.closest("cart-drawer") &&
        (i = () => {
            e.closest("cart-drawer").close();
        }),
    "menu-drawer" === e.id &&
        e.closest("header-drawer") &&
        (i = () => {
            e.closest("header-drawer").closeMenuDrawer(!0);
        }),
    ((e.classList.contains("menu-drawer__submenu") && e.id.startsWith("childlink-")) || (e.classList.contains("menu-drawer__submenu") && e.id.startsWith("link-"))) &&
        (i = () => {
            e.closest("menu-drawer").closeSubmenu(e.closest("menu-drawer").mainDetailsToggle);
        }),
    e.classList.contains("mobile-localization-form__submenu") &&
        e.closest("mobile-localization-form") &&
        (i = () => {
            e.closest("mobile-localization-form").closeSelector();
        }),
    new SwipeMobile(e, t, 160, 400, i);
});

document.addEventListener("DOMContentLoaded", function () {
const videoControls = document.querySelectorAll(".js-video-control");
for (const videoControl of videoControls) {
const ariaLabelPlay = videoControl.getAttribute("data-aria-label-play");
const ariaLabelPause = videoControl.getAttribute("data-aria-label-pause");
const video = videoControl.parentElement.querySelector("video");
let multipleVideos = null
if (videoControl.classList.contains('video-control-card')) {
    const videoParent = videoControl.parentElement;
    multipleVideos = videoParent.querySelectorAll("video");
}
if (video) {
  video.addEventListener("play", function () {
    videoControl.setAttribute("aria-pressed", "true");
    videoControl.setAttribute("aria-label", ariaLabelPause);
  });
  video.addEventListener("pause", function () {
    videoControl.setAttribute("aria-pressed", "false");
    videoControl.setAttribute("aria-label", ariaLabelPlay);
  });
  if (video.paused) {
    videoControl.setAttribute("aria-pressed", "false");
    videoControl.setAttribute("aria-label", ariaLabelPlay);
  } else {
    videoControl.setAttribute("aria-pressed", "true");
    videoControl.setAttribute("aria-label", ariaLabelPause);
  }
  videoControl.addEventListener("click", function () {
    if (video.paused) {
      video.play();
      video.removeAttribute("data-paused");
      video.classList.add('buttoned-play');
      video.classList.remove('buttoned-pause');
      if (multipleVideos) {
        multipleVideos[1].play();
        multipleVideos[1].classList.add('buttoned-play');
      };
    } else {
      video.pause();
      video.setAttribute("data-paused", "true");
      video.classList.remove('buttoned-play');
      video.classList.add('buttoned-pause');
      if (multipleVideos) {
        multipleVideos[1].pause();
        multipleVideos[1].classList.remove('buttoned-play');
      };
    }
  });
}
}
});

// Added no scroll class to disable scroll on mobile menu
document.addEventListener("DOMContentLoaded", function () {
  const navToggle = document.querySelector('.menu-drawer-container .header__icon-wrapper svg');
  const menuDrawerCloseButton = document.querySelector('#menu-drawer .menu-drawer__close-button');
  const html = document.documentElement;
  let scrollPos = 0;
  navToggle.addEventListener('click', () => {
    scrollPos = window.pageYOffset;
    html.classList.toggle('no-scroll');
  });
  menuDrawerCloseButton.addEventListener('click', () => {
    html.classList.remove('no-scroll');
    window.scrollTo(0, scrollPos)
  });
});

function getCartProductQuantities() {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const productQuantities = {};

      cart.items.forEach(item => {
        const productId = item.product_id;
        if (!productQuantities[productId]) {
          productQuantities[productId] = 0;
        }
        productQuantities[productId] += item.quantity;
      });

      return productQuantities;
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      return {};
    });
}
